<template>
  <div :class="isMobile && 'redcat-app-mobile-login'">
    <div v-if="!isMobile" class="login-box">
      <div class="login-container">
          <span class="admin-back-code-login" v-if="codeLoginToaccountLogin" @click="toCodeLogin">返回二维码登录</span>
          <!-- 切换登录方式 -->
          <div class="tab-box">
            <div class="login-tab" v-if="allowLoginType==='both'">
              <div class="login-switch" @click="switchLogin">
                <span class="account-img" v-if="loginType==='accountLogin'"></span>
                <span class="code-img" v-if="loginType!=='accountLogin'"></span>
                <div class="login-tip">
                  {{loginType==='accountLogin'?'扫码登录更安全':'账号密码在这里'}}
                </div>
                <div class="sanjiao"></div>
              </div>
            </div>
          </div>
          <!-- 平台名称 -->
          <div class="logo-group">
            <p>{{applicationName}}</p>
          </div>

          <!--登录框账号密码登录-->
          <div class="account-login" v-show="loginType==='accountLogin'">
            <el-form label-width="100px" label-position="left" :model="verify">
              <div class="control-group" :class="active==='user'?'active':''">
                <i class="user-icon login-pre-icon"></i>
                <input class="login-input" v-focus v-model="loginParams.username"  type="text" placeholder="请输入手机号/用户名" @focus="active='user'" @keyup.enter="login"/>
                <i class="login-last-icon" @click.stop="loginParams.username=''"></i>
              </div>
              <div class="control-group why-different" :class="active==='pwd'?'active':''">
                <i class="pwd-icon login-pre-icon"></i>
                <input class="password" type="password" v-focus v-model="loginParams.password" placeholder="请输入密码"  @keyup.enter="login" @focus="active='pwd'"/>
                <i class="login-last-icon" @click.stop="loginParams.password=''"></i>
              </div>
              <div class="login-group" v-if="showImageCode">
                <image-verify-code ref='codeImg' v-model="verify.imageCode" prop="imageCode"/>
              </div>
              <div class="control-group login-btn">
                <button :disabled="buttonDisabled" class="login-button" @click="login" type='button' :class=" buttonDisabled ? 'logining':''">{{buttonDisabled?'登录中':'登录'}}
                  <i class="el-icon-loading" v-show="buttonDisabled"></i>
                </button>
              </div>
              <div class="control-group forget-password-a">
                <a class="resetAccount" href="/forget-password" target="_self">忘记密码？</a>
              </div>
            </el-form>
          </div>
        <!-- 二维码登录 -->
        <div class="code-login" v-show="loginType==='codeLogin'">
          <div class="code">
            <img v-if="codeLogin.codeImg" :src="codeLogin.codeImg" alt="请打开企业微信扫一扫登录">
          </div>
          <div class="control-group sao">请打开企业微信扫一扫登录
            <span class="admin-code-login" @click="toAccountLogin" v-if="allowLoginType === 'codeLogin'">超管账号登录</span>
          </div>
        </div>
      </div>
    </div>
    <!-- mobile 登录 -->
    <div v-else class="mobile-login">
      <div class="application-name">{{applicationName}}</div>
      <div class="mobile-login-body">
        <el-input v-focus v-model="loginParams.username" placeholder="请输入账号" @keyup.enter="login">
          <i slot="prefix" class="user-icon login-pre-icon"></i>
        </el-input>
        <el-input type="password" v-model="loginParams.password" placeholder="请输入密码" @keyup.enter="login">
          <i slot="prefix" class="pwd-icon login-pre-icon"></i>
        </el-input>
        <el-button type="primary" @click="login">登录</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import qs from 'qs'
import axios from 'axios'
import ImageVerifyCode from './image-verify-code.vue'
import md5 from 'md5'
import CookieOperation from '@/plugins/cookie'
import { userInfo } from '@/store/app-common-data/userInfo.js'
import tokenStorage from '@/plugins/tokenStorage'
export default {
  name: 'loginComponent',
  props: ['allowLoginType', 'applicationName', 'isMobile'],
  components: {ImageVerifyCode},
  data () {
    let loginType = ''
    switch (this.allowLoginType) {
      case 'codeLogin':
      case 'both':
        loginType = 'codeLogin'
        break
      case 'accountLogin':
        loginType = 'accountLogin'
        break
      default:
        loginType = 'accountLogin'
    }
    return {
      showImageCode: false,
      verify: {
        imageCode: ''
      },
      loginParams: {
        username: '',
        password: ''
      },
      city: {
        cityIp: '',
        cityId: '',
        cityName: ''
      },
      loginType,
      codeLogin: {
        codeImg: '',
        timer: null
      },
      active: '',
      buttonDisabled: false,
      loginId: '',
      codeLoginToaccountLogin: false // 系统设置二维码登录：从二维码登录方式切换至密码登录
    }
  },
  directives: {
    focus: {
      inserted: function (el, {value}) {
        let latestUsername = localStorage.getItem('latestUsername')
        if (latestUsername && el.className === 'password') {
          setTimeout(() => {
            el.focus()
          }, 1000)
        } else if (!latestUsername && el.className === 'login-input') {
          setTimeout(() => {
            el.focus()
          }, 1000)
        }
      }
    }
  },
  mounted () {
    axios.defaults.paramsSerializer = (params) => qs.stringify(params, {arrayFormat: 'brackets'})
    axios.interceptors.request.use(
      config => {
        const token = sessionStorage.getItem('token') || localStorage.getItem('token') || undefined
        // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
        if (token) {
          config.headers.Authorization = token
        }
        return config
      },
      err => Promise.reject(err)
    )
    axios.interceptors.response.use(
      res => res,
      error => {
        // 先检查是否禁用拦截器，再检查错误请求的类型
        if (!error.config.disableInterceptors) {
          if ([400, 401, 404, 500].includes(error.response.status)) {
            let message
            if (error.response.status !== 500) {
              message = error.response.data.message
            }

            this.openMessage(message || '系统异常，请稍候重试！')
          }
        }

        // 返回 response 里的错误信息
        return Promise.reject(error)
      }
    )
    this.$nextTick(() => {
      let latestUsername = localStorage.getItem('latestUsername')
      if (latestUsername) {
        this.loginParams.username = latestUsername
      }
    })
  },
  watch: {
    allowLoginType () {
      switch (this.allowLoginType) {
        case 'codeLogin':
        case 'both':
          this.loginType = 'codeLogin'
          break
        case 'accountLogin':
          this.loginType = 'accountLogin'
          break
        default:
          this.loginType = 'accountLogin'
      }
      if (this.loginType === 'codeLogin') {
        this.getCode()
      }
    }
  },
  methods: {
    getToken () {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token') || undefined
      return token && token.substring(7)
    },
    setToken (token, persist) {
      (!persist ? sessionStorage : localStorage).setItem('token', `bearer ${token}`)
    },
    toAccountLogin () {
      this.loginType = 'accountLogin'
      this.codeLoginToaccountLogin = true
    },
    toCodeLogin () {
      this.loginType = 'codeLogin'
      this.codeLoginToaccountLogin = false
    },
    async validate () {
      let tenantId = CookieOperation.get('tenantId')
      await this.$axios.get('/auth-api/login/superiorLoginType', {params: {userName: this.loginParams.username, tenantId}}).then((res) => {
        this.showImageCode = res.data
      })
      if (this.loginParams.username !== 0 && !this.loginParams.username) {
        this.$message.error('用户名不能为空')
        throw new Error('用户名不能为空!')
      } else if (this.loginParams.password !== 0 && !this.loginParams.password) {
        this.$message.error('密码不能为空')
        throw new Error('用户名不能为空!')
      } else if (this.showImageCode) {
        if (this.verify.imageCode !== 0 && !this.verify.imageCode) {
          this.$message.error('验证码不能为空')
          throw new Error('验证码不能为空!')
        }
        let md5ImgCode = md5(this.verify.imageCode.toUpperCase())
        if (md5ImgCode.toUpperCase() !== CookieOperation.get('verificationCode')) {
          this.$message.error('请输入正确的验证码')
          throw new Error('请输入正确的验证码')
        }
      }
    },
    // 登入接口
    login () {
      // 如果按钮禁用，回车不能用
      if (this.buttonDisabled) {
        return
      }
      if (this.codeLoginToaccountLogin) {
        if (this.loginParams.username && this.loginParams.username !== 'admin') {
          return this.$message.error('仅限超管账号登录，其他账号请切换至二维码方式进行登录！')
        }
      }
      this.validate()
        .then(() => {
          this.buttonDisabled = true
          return this.loginIn()
        })
        .then(this.loginSuccessful)
        .then(() => {
          this.buttonDisabled = false
          // 非管理员登陆时,在localStorage中存储登录的用户名
          if (this.loginParams.username !== 'admin') {
            localStorage.setItem('latestUsername', this.loginParams.username)
          }
        })
        .catch(() => {
          this.buttonDisabled = false
        })
    },
    loginIn () {
      return axios({
        url: '/auth-api/oauth/token',
        method: 'post',
        data: {
          username: this.loginParams.username,
          password: this.loginParams.password,
          userType: this.loginParams.username === 'admin' ? 'admin' : 'default',
          grant_type: 'password',
          client_secret: '123456',
          client_id: 'rc-client',
          scope: 'read',
          response_type: 'token'
        },
        // 这串必须加 否则参数会带上引号导致登入失败
        transformRequest (data) {
          let formDataArray = []
          for (let index in data) {
            formDataArray.push(encodeURIComponent(index) + '=' + encodeURIComponent(data[index]))
          }
          return formDataArray.join('&').toString()
        }
      })
    },
    async loginSuccessful (response) {
      const token = response.data['access_token']
      this.setToken(token, true)
      await this.loginRecord(this.loginParams.username)
      // 如果是手机端登录，不需要判断是否为第一次登录，也不需要判断 admin 账号，直接跳转企业微信页面
      if (this.isMobile) {
        await this.$axios.get('/shared-api/qywxconfig/getDomain').then(({data}) => {
          // 在当前页面打开企业微信
          window.location.href = `${data}/index?token=${token}&tenantId=${CookieOperation.get('tenantId')}`
        })
      } else {
        let isAdmin = this.loginParams.username === 'admin'
        sessionStorage.setItem('admin', JSON.stringify(isAdmin))
        // 首次登陆
        let isFirstLoginIn = (await this.isFirstLogin()).data
        if (isFirstLoginIn) {
          this.$router.push({ path: '/first-change-password', query: { token: this.getToken(), pwd: this.loginParams.password } })
        } else {
          this.$router.push({ name: 'index', query: { token: this.getToken() } })
        }
      }
    },
    loginRecord (userName) {
      return axios.post('/auth-api/login/auth/loginRecord', {
        userName: userName
      })
    },
    clearGlobalData () {
      Reflect.ownKeys(userInfo).forEach(key => {
        delete userInfo[key]
      })
    },
    // 登出
    logout () {
      document.cookie = 'securityPw=false'
      sessionStorage.removeItem('currentUserId')
      tokenStorage.removeToken()
      // 清理掉一些退出时要处理的全局数据，比如全局保存的用户信息
      this.clearGlobalData()
      this.$router.push({ name: 'login' })
    },
    isFirstLogin () {
      return axios.get('/auth-api/login/auth/isFirstLogin')
    },

    // 切换登录方式
    switchLogin () {
      this.loginType = this.loginType === 'accountLogin' ? 'codeLogin' : 'accountLogin'
      if (this.loginType === 'codeLogin') {
        this.getCode()
      }
    },
    getCode () {
      if (this.codeLogin.timer !== null) {
        clearInterval(this.codeLogin.timer) // 取消定时器
      }
      this.getTenantId()
      let _this = this
      this.codeLogin.timer = setInterval(() => {
        if (_this.$route.name.includes('login') && _this.loginType === 'codeLogin') {
          _this.getResponseLoginId()
        } else {
          clearInterval(_this.codeLogin.timer) // 取消定时器
        }
      }, 1500)
    },
    getQrCode (tenantId) {
      return axios.get('/system-api/qywxCallback/getQrCodeByQyWeChat', {params: {
        tenantId: tenantId
      }}).then((res) => {
        this.codeLogin.codeImg = 'data:image/png;base64,' + res.data.data.image
        this.loginId = res.data.data.loginId
      })
    },
    getTenantId () {
      let tenantId = CookieOperation.get('tenantId')
      if (tenantId) {
        this.getQrCode(tenantId)
      } else {
        let domain = document.domain
        if (domain === 'localhost') {
          domain = CookieOperation.get('domain') || console.warn('本地开发设置 cookie.domain') || '2405.rc-dev-test.ywsoftware.cn'
        }
        this.$axios.get('/system-api/application/getSettingByDomain', { params: { domain }, timeout: 30000, disableInterceptors: true })
          .then(res => {
            let data = res.data
            if (!(data && data.data)) {
              return this.message.error('获取租户信息失败')
            } else {
              tenantId = data.data.id
              tenantId && this.getQrCode(tenantId)
            }
          })
      }
    },
    getResponseLoginId (loginId = this.loginId) {
      axios.get(`/system-api/qywxCallback/getQrCodeLoginAuthorization?loginid=${loginId}`)
        .then((response) => {
          if (!response.data.code) return null
          if (response.data.code === 1) {
            // code === 表示扫码登录成功
            this.loginSuccessful(response.data)
            let username = response.data.data['username'] || ''
            this.loginRecord(username)
          } else if (response.data.code === 2) {
            // code === 2 表示二维码过期
            this.getCode()
          }
        })
    },
    openMessage (tip) {
      this.$emit('openMessage', tip)
    }
  }
}

</script>

<style lang="scss">
@mixin borderNone () {
  border-top: none;
  border-left: none;
  border-right: none;
}
.login-wrapper {
  width: 100%;
  height: 100%;
  margin: 0;
  background-size: 100% 100%;

  .login-box {
    width: 424px;
    height: 390px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 0 4px 1px rgba(237, 244, 249, 0.6);
    margin: 0 auto;
    position: absolute;
    top: 45%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    overflow: hidden;
  }

  .login-container {
    width: 344px;
    margin: 0 auto;
    margin-top: 12px;

    .admin-back-code-login {
      position: absolute;
      right: 40px;
      bottom: 30px;
      color: #4592E4;
      &:hover {
        cursor: pointer;
        color: #3378c2;
      }
    }

    .why-different {
      margin-bottom: 25px;
    }

    .logo-group {
      text-align: center;
      margin-top: -10px;

      img {
        max-height: 100%;
        height: 70px;
        width: 88px;
      }

      p {
        font-size: 24px;
        color: #22262E;
        font-family: MicrosoftYaHeiLight;
      }
    }

    .tab-box {
      height: 35px;

      .login-tab {
        position: relative;
        height: 40px;
        width: 100%;

        .login-switch {
          position: absolute;
          top: 0px;
          right: -24px;
          cursor: pointer;
          width: 35px;
          height: 35px;

          .account-img {
            width: 35px;
            height: 35px;
            display: block;
            background: url('./assets/qc.png') no-repeat center;
            &:hover {
              /*background: url('./assets/qchover.png') no-repeat center;*/
              /* 通过投影与透明边框隐藏将内容区域挤占，同时往原来的区域投影*/
              border-right: 35px solid transparent;
              border-left: 70px solid transparent;
              filter: drop-shadow(-53px 0 0 var(--primary, #4592E4));
            }
          }

          .code-img {
            width: 34px;
            height: 33px;
            display: block;
            background: url('./assets/code.png') no-repeat center;

            &:hover {
              /*background: url('./assets/codehover.png') no-repeat center;*/
              border-right: 35px solid transparent;
              border-left: 70px solid transparent;
              filter: drop-shadow(-53px 0 0 var(--primary, #4592E4));
            }
          }

          &:hover {
            .login-tip {
              display: block;
            }
          }

          .sanjiao {
            position: absolute;
            right: 33px;
            top: 20px;
            width: 0;
            height: 0;
            border-right: 4px solid transparent;
            border-top: 4px solid transparent;
            border-bottom: 4px solid transparent;
            border-left: 6px solid #EEF6FF;
          }

          .login-tip {
            position: absolute;
            width: 133px;
            top: 40px;
            height: 26px;
            right: -9px;
            color: var(--font-1, #7199C3);
            font-size: 10px;
            line-height: 26px;
            text-align: center;
            background: var(--light-9, #EEF6FF);
            border-radius: 4px;
            display: none;
          }
        }

      }
    }

    .control-group {
      width: 100%;
      height: 38px;
      margin: 0 0 15px 0;
      overflow: hidden;
      color: #62a8f2;
      font-size: 14px;
      position: relative;

      &.yzm-group {
        display: inline-block;
      }
      &.login-btn {
        margin-top: 35px;
        height: 42px;
        line-height: 42px;
      }
      &.active{
       .login-pre-icon.user-icon {
           /*background: url('./assets/user-2.png') no-repeat center;*/
           /*background-size:contain;*/
           filter: drop-shadow(25px 0 0 var(--primary, #4592E4));
           margin-left: -25px;
        }
        .login-pre-icon.pwd-icon {
           /*background: url('./assets/pwd-2.png') no-repeat center;*/
           /*background-size:contain;*/
           filter: drop-shadow(25px 0 0 var(--primary, #4592E4));
           margin-left: -25px;
        }
      }
      &:hover,&:active{
        .login-last-icon {
          display:inline-block;
        }
      }
    }
    .login-group{
      .image-verify-code{
        .el-form-item{
          margin-bottom: 0px;
          .el-form-item__label{
            padding: 0px;
          }
          .el-form-item__content{
            height: 40px;
            margin-left: 0px !important;
            .verify-input{
              width: 200px;
              height: 50px;
              .img-code{
                width: 200px;
                input{
                  width: 200px;
                  background: white;
                }
              }
            }
            .verify-img{
              position: absolute;
              right: 0px;
            }
          }
        }
      }
    }
    .control-group:not(:last-child) input {
      border: none;
      border-bottom: 1px solid #E7E5E3;
      outline: none;
      border-radius: 0;
      width: 100%;
      font-size: 14px;
      padding: 0 0 2px 34px;
      color: #22262E;
      background-color: #fff;
      height: 35px;

      &:active,
      &:focus {
        border-color: var(--primary, #62a8f2);

        &+span {
          color: #62a8f2;
        }
      }
    }
    .forget-password-a {
      margin-bottom: 0;
      height: 35px;
    }

    .account-login {
      margin-top: 50px;
      .login-pre-icon {
        position: absolute;
        left: 10px;
        top: 10px;
        width: 14px;
        height: 14px;
        color: #c0c4cc;
        &.user-icon {
           background: url('./assets/user-1.png') no-repeat center;
           background-size:contain;
        }
        &.pwd-icon {
           background: url('./assets/pwd-1.png') no-repeat center;
           background-size:contain;
        }
       }
       .login-last-icon {
         width: 13px;
         height: 14px;
         position: absolute;
         right: 9px;
         top: 12px;
         cursor:pointer;
         display:none;
         background: url('./assets/del.png') no-repeat center;
         background-size:cover;
       }

      .nc-container {
        height: 36px;
        margin-bottom: 15px;

        .nc_scale {
          width: 345px;
          height: 36px;
          border-radius: 3px;

          .nc_bg {
            height: 36px;
            border-radius: 3px 0 0 3px;
          }

          .nc-lang-cnt {
            height: 36px;
            line-height: 36px;
          }

          .scale_text2 {
            line-height: 36px;
          }

          .btn_slide {
            height: 36px;
            border-radius: 4px 0 0 4px;
          }

          .btn_ok {
            height: 36px;
            border-radius: 0 4px 4px 0;
          }
        }
      }

      .login-button {
        border: none;
        border-radius: 4px;
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        display: block;
        width: 100%;
        height: 100%;
        text-align: center;
        cursor: pointer;
        font-size: 14px;
        background: var(--primary, #409eff);
        border-color: var(--primary, #409eff);
        color:#fff;
        line-height: 37px;
        &:hover {
          background: var(--light-2, #62A8F2);
          border-color: var(--light-2, #62A8F2);
        }
        &:active {
          background: var(--shade-1, #3a8ee6);
          border-color: var(--shade-1, #3a8ee6);
        }
        &.logining{
          background: var(--light-2, #62A8F2);
          border-color: var(--light-2, #62A8F2);
        }
      }

    }

    .code-login {
      text-align: center;
      margin-top: 18px;

      .code {
        width: 212px;
        height: 212px;
        background: #fff;
        border: 1px solid #EDEDED;
        box-shadow: 0px 2px 17px 1px rgba(98, 168, 242, 0.11);
        margin: 0 auto;

        img {
         width: 192px;
         height: 192px;
         display: block;
         margin: 9px auto;
        }
      }

      .control-group.sao {
        color: #808080;
        font-size: 16px;
        margin-top: 15px;
        height: 50px;
        .admin-code-login {
          position: absolute;
          right: 0;
          bottom: 0;
          color: #4592E4;
          &:hover {
            cursor: pointer;
            color: #3378c2;
          }
        }
      }
    }

    .logo-browser {
      text-align: center;
      font-size: 14px;
      color: #808080;
      & > a {
        color: #808080;
        &:hover {
          color: blue;
        }
      }
    }
  }

}
.keep-record {
  position: absolute;
  bottom: 18px;
  left: 50%;
  color: #22262E;
  transform: translateX(-50%);
}
.resetAccount {
  text-decoration: none;
  float: right;
  font-size: 14px;
  color: #808080;
}
.redcat-app-mobile-login {
  @mixin Center () {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  width: 100%;
  height: 100%;
  overflow: hidden;
  @include Center;

  .mobile-login {
    width: 80%;
    height: 35%;
    box-shadow: 0 0 4rem 1rem rgba(237, 244, 249, 0.6);
    background-color: #fff;
    margin: 0 auto;

    .application-name {
      font-size: 4rem;
      text-align: center;
      padding: 3rem 0;
      color: #22262e;
    }

    .mobile-login-body {
      padding: 2rem 3rem 0 3rem;

      .el-input {
        font-size: 2rem;
        height: 6rem;
        margin-bottom: 3rem;
        border-radius: 1rem;
        @include borderNone;
        .el-input__inner {
          height: 6rem;
          line-height: 3rem;
          @include borderNone;
        }
      }

      .el-button {
        height: 5.5rem;
        line-height: 5.5rem;
        width: 100%;
        padding: 0;
        border-radius: 1rem;
        span {
          font-size: 2.5rem;
        }
      }

      .el-input--prefix {
        padding-left: 1rem;

        .el-input__prefix {
          @include Center;
          margin-right: 1rem;

          .user-icon {
            background: url('./assets/user-1.png') no-repeat center;
            background-size:contain;
          }

          .pwd-icon {
            background: url('./assets/pwd-1.png') no-repeat center;
            background-size:contain;
          }

          .login-pre-icon {
            display: inline-block;
            width: 2rem;
            height: 2rem;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/system/login-component.vue